import { UserInfo } from '@/types/Auth'

const userInfoStore = {
  userInfo: new UserInfo(),
  setUserInfo: (userInfo: UserInfo) => {
    userInfoStore.userInfo = userInfo as any
  },
  inRootDomain: () => {
    return userInfoStore.userInfo.domain.name === 'root'
  },
  hasPermission: (permission: string): boolean => {
    return userInfoStore.userInfo.role.permissions.some(
      p => p.name === permission
    )
  },
  hasPermissions: (permissions: string[]): boolean => {
    return permissions.every(permission =>
      userInfoStore.hasPermission(permission)
    )
  },
  hasRole: (role: string): boolean => {
    return userInfoStore.userInfo.role.name === role
  }
}

export default userInfoStore
